import { ServiceRoute, GLServiceBase } from "../../src/commonui/services/service";
import { ComponentContentStateModel } from "@/services/content";

class ComponentServiceClass extends GLServiceBase<any, any> {
	serviceRoute: ServiceRoute = { prefix: "content/v1/component" };

	getComponentContentState(
		componentId: string,
		revision: number,
		grapeSeedVersion?: string,
		littleSeedVersion?: string
	): Promise<ComponentContentStateModel> {
		return this.get("{componentId}/contents-state", {
			componentId,
			revision,
			grapeSeedVersion,
			littleSeedVersion
		});
	}
}

export const ComponentService = new ComponentServiceClass();
